import { useEffect, useState } from "react";
import { LoaderCircle } from "lucide-react";

type LoadingOverlayProps = {
  active: boolean;
  label?: string;
};

export function LoadingOverlay({ active, label = "正在加载" }: LoadingOverlayProps) {
  const [rendered, setRendered] = useState(active);
  const [visible, setVisible] = useState(active);

  useEffect(() => {
    if (active) {
      setRendered(true);
      const frame = window.requestAnimationFrame(() => setVisible(true));
      return () => window.cancelAnimationFrame(frame);
    }

    setVisible(false);
    const timeout = window.setTimeout(() => setRendered(false), 220);
    return () => window.clearTimeout(timeout);
  }, [active]);

  if (!rendered) {
    return null;
  }

  return (
    <div className={`loading-overlay${visible ? " is-visible" : ""}`} role="status" aria-live="polite" aria-label={label}>
      <LoaderCircle className="loading-overlay-icon" size={25} strokeWidth={1.8} aria-hidden="true" />
    </div>
  );
}
